import { SlideInPanelAnchorLocation } from "@redotech/redo-model/slide-in-panel/slide-in-panel-anchor-location";
import XCloseIcon from "@redotech/redo-web/arbiter-icon/x-close.svg";
import { IconButton } from "@redotech/redo-web/button";
import { Flex } from "@redotech/redo-web/flex";
import * as classNames from "classnames";
import { memo, useMemo } from "react";
import * as slideInPanelCss from "./slide-in-panel.module.css";

export const SlideInPanel = memo(function SlideInPanel({
  children,
  anchorLocation,
  open,
  setOpen,
}: {
  children: React.ReactNode | React.ReactNode[];
  anchorLocation: SlideInPanelAnchorLocation;
  open: boolean;
  setOpen: (open: boolean) => void;
}) {
  const _anchorLocation = useMemo(() => {
    switch (anchorLocation) {
      case SlideInPanelAnchorLocation.BOTTOM_LEFT:
        return slideInPanelCss.bottomLeft;
      case SlideInPanelAnchorLocation.BOTTOM_RIGHT:
        return slideInPanelCss.bottomRight;
    }
  }, []);

  return open ? (
    <Flex
      className={classNames(slideInPanelCss.panelContainer, _anchorLocation)}
    >
      <IconButton
        className={slideInPanelCss.closeIconButton}
        onClick={() => setOpen(false)}
      >
        <XCloseIcon />
      </IconButton>
      {children}
    </Flex>
  ) : null;
});
